export const enum FormFieldEnum {
    MyInput = "MyInput",
    MyRadioGroup = "MyRadioGroup",
    MyCheckbox = "MyCheckbox",
    MySelect = "MySelect",
    MyFile = "MyFile",
    ZipCode = "ZipCode",
    City = "City",
    Street = "Street",
    holderEmail = "holderEmail",
    MyCalendar = "MyCalendar"
}
